// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__1MrDW","hidden":"pagination_hidden__qom91","page":"pagination_page__fKdV9","active":"pagination_active__c4hm5"};